<template>
   <div class="address_profile user_profile_wrap">
       <div class="flex_address_top">
           <div class="title">{{get_local_string.string_43}}</div>
        <b-button class="mb-5 addbtnaddress" @click="show_modal_map()" type="is-success" size="is-small"
            > <i class="fas fa-map-marker-alt newIcons"></i> {{get_local_string.string_21}}</b-button>
       </div>


        <div class="is_choose_delvery">
            <!-- <hr class="mt-1 "> -->
            <template v-if="user.addressList.length>0">
            <div class="address_list profile_address">
                <!-- {{user.addressList}} -->
                                         <b-field v-for="address in  user.addressList" :key="address.id" class="myaddressRadio">
                    <b-radio v-model="radio_address"
                        :native-value="address.id"
                        type="is-success">
                        <span class="adress_text">{{address.address_text}}
                        </span>
                        <!-- <span class="distance"></span> -->
                        <span class="right_address">
                            <span class="adress_price">{{address.price}}{{get_setting_app.payment.currency}}</span>
                            <span class="Kms">{{address.distance}} {{get_local_string.string_22}}</span>
                        </span>
                        <span class="note">{{address.min_order_alert}}</span>
                    </b-radio>
                    <b-button class="removeAddress" @click="removeAddress(address.id)" size="is-small" type="is-danger"><i class="fas fa-trash-alt"></i></b-button>
                </b-field>
                </div>
            </template>
            <template v-else>
            <div class="noAddress_wrap">
                <img src="@/assets/no_address.svg" alt="">
                <p>{{get_local_string.string_23}}</p>
            </div>
            </template> 
        </div>
         <googlePlacescomp></googlePlacescomp>
   </div>
</template>
<script>
import $ from 'jquery';
import googlePlacescomp from '@/components/global/googleplaces.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:'addressprofile',
     components:{googlePlacescomp},
     data(){
         return{
              radio_address:null,
         }
     },
     computed:{
         ...mapGetters({
             user:'auth/user',
             get_setting_app:'get_setting_app',
               get_local_string:'get_local_string'
         })
     },
     methods:{
         ...mapActions({
             remove_address:'remove_address',
         }),
            removeAddress(address_id){
            // console.log('delete address', address_id);
            this.remove_address(address_id).then(()=>{
                this.errorMsg = 'Address removed successfully';
                this.danger();
                //   console.log('address lenght remove',this.user)
            }); 
        },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
         show_modal_map(){
        this.uk.modal($('#modal-container')).show();
        },
     },
     mounted(){
     }
}
</script>
<style lang="scss">

.profile_address label .check{
    display: none !important;
}
.profile_address{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 20px;
    .field{
        flex: 0 0 45%;
    }
}
</style>
<style lang="scss" scoped>
.grand_total_with_delevery{
    font-weight: 700;
    color: white;
}

.plus_devery_price{
    color: #49c68d;
}
.field{
    position: relative;
.removeAddress{
   position: absolute;
    right: -8px;
    top: -8px;
    border-radius: 100% !important;
    width: 30px;
    height: 30px;
}
}
.noAddress_wrap{
  text-align: center;
  padding-bottom: 20px;
  img{
    width: 350px;
    object-fit: contain;
  }
  p{
        font-size: 15px;
    font-weight: 500;
    margin-top: 20px;
  }
}
.address_list{
    padding: 0px 20px 40px 20px;
    .b-radio .control-label {
    margin-top: -1px !important;
        }
    .b-radio{
    border: 1px solid #5b5e603a;
        background-color: whitesmoke;
    color: black;
    padding: 20px 14px;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 13px;
    width: 100%;
    padding-right: 30px;
    align-items: flex-start;
    &:hover{
        color: black;
        border: 1px solid var(--active_color);
    }
   
    }
    .distance{
    margin: 0px 10px;
    font-weight: 800;
    }
    .adress_price{
    display: block;
    font-weight: 800;
    color: #49c68d;
    font-size: 15px;
    }
    .note{
    margin-top: 4px;
    display: block;
    color: #f14667;
    font-weight: 500;
    font-size: 12px;
        position: absolute;
    bottom: 8px;
    }
}
.flex_list_add{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
}
.addbtnaddress{
    font-weight: 700;
}
 .newIcons{
  font-size: 13px !important;
    margin-right: 4px;
        }
.address_title{
    color: white;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}
.flex_delevey{
    display: flex;
    justify-content: space-between;
    padding: 20px 14px;
    align-items: center;
      .option_levering.selected_mehods{
        //   pointer-events: none;
         border: 1px solid #fff;
        .levering_title{
                color: #fff;
        }
        img{
                 opacity: 1;
            }
    }
    .option_levering{
           text-align: center;
            flex: 0 0 40%;
            border: 1px solid #575757;
            padding: 18px 0px;
            border-radius: 4px;
             transition: 0.3s linear;
            cursor: pointer;
        .levering_title{
               display: block;
                font-size: 18px;
                margin-top: 10px;
                font-weight: 600;
                color: #575757;
                 transition: 0.15s linear;
        }
        img{
                filter: invert(1);
                 width: 110px;
                 opacity: 0.5;
                  transition: opacity 0.15s linear;
            }
        label{
            display: none;
        }
    }
}
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
    .address_title{
        visibility: hidden;
    }
}
.flex_address_top{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media(max-width:992px){
    .profile_address .field {
    flex: 0 0 100% !important;
}
.address_list{
    padding: 0px 4px 40px 4px;
    .b-radio.radio .control-label {
    font-size: 11px !important;
}
}


}

</style>